import uuid from 'uuid';
import Dispatcher from '../dispatcher/dispatcher';

// フォーム上へページ内スクロール
const _scrollOnForm = () => {
	const anchor = document.getElementById('app-view');
	const header = document.querySelector('.nav');
	const headerHeight = header ? header.offsetHeight : 0;

	if (anchor) {
		const targetPosition = anchor.offsetTop - headerHeight;
		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	}
}

class InputActions {
  changeInput(event) {
    let value = event.target.value
      , name  = event.target.name
      , checked = event.target.checked;

    return Dispatcher.dispatch({type: 'change', params: {name: name, value: value, checked: checked}});
  }

  onConfirm(event) {
    event.preventDefault();
    _scrollOnForm();

    return Dispatcher.dispatch({type: 'confirm'});
  }

  onNext(event) {
    event.preventDefault();
    _scrollOnForm();

    return Dispatcher.dispatch({type: 'next'});
  }

  onBack(event) {
    event.preventDefault();
    _scrollOnForm();

    return Dispatcher.dispatch({type: 'back'})
  }

  onSubmit(event) {
    let form = document.getElementById('#houkoku_form');
    if (form) {
      form.method = "POST";
      form.action = "./send.php";
      form.submit();
    }
  }
}

export default new InputActions(Dispatcher);
